


var macuriwebmac = function() {
 var body = $('body'),
  getId = null,                       //-------> variable vacia
  isMobile = !1,                      //-------> variable false
  urlPathname = window.location.pathname,//---> ruta y el nombre de archivo de la página actual
  // domainurl = window.location.hostname,//--->tambien (host) ruta del dominio
  domainurl = 'http://localhost/bullet/public'; 

 Toptitop = function() { 
  if ( (/windows phone/i.test(navigator.userAgent)) ||(/android/i.test(navigator.userAgent)) || 
    (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)      ) {
        isMobile = !0;  //---->se convierte en true
    };
	  fn.documentAjax();
	  fn.documentOnload();
	  fn.documentReady();
  },
	fn = { 
	 	documentAjax: function()   {
	  	$(document).ajaxStop(function() { 
      }); 
    },
	 	documentOnload:function()  { 
	  	$(window).on('load', function() {
	  	});	
 	 	},
	 	documentReady: function()  {
 	    fn.otros()
 		  fn.notiEfect()
   		fn.scrollHome()
  	  fn.efectZoom()
  	  fn.carruselMarcas()
 	    fn.carruselProdNuevo()
	    fn.galervideo()
	    fn.scriptBaykal()
	    fn.carrusel_cursos()
     },
		galervideo: function(){//------> Galeria videos
			const clip = document.querySelectorAll('.clip');
			for ( let i=0; i < clip.length;  i++){
				clip[i].addEventListener('mouseenter',
					function(e){
					clip[i].play();
				})
				clip[i].addEventListener('mouseout',
					function(e){
					clip[i].pause();
				})		
			}
    },	
 		otros: function() {		//-------> OTROS Element 
 				$('[data-fancybox="images"]').fancybox({
						     afterLoad : function(instance, current) {
						        var pixelRatio = window.devicePixelRatio || 1;

						        if ( pixelRatio > 1.5 ) {
						            current.width  = current.width  / pixelRatio;
						            current.height = current.height / pixelRatio;
						        }
						    }
				});
		},
		scrollHome: function() {//-----> SCROL Home    
		    $('a[href*="#"]:not([href="#"])').click(function() {
	            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
	                var target = $(this.hash);
	                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	                if (target.length) {
	                    $('html, body').animate({
	                    scrollTop: target.offset().top-= 50
	                    }, 1000 ,   'easeOutBounce');
	                    return false;
	                }
	           }
            }); 
	        $.scrollUp({//-----> Scrollup Home 
	            // topDistance: '1500', // Distance from top before showing element
	            scrollText:"",
	            scrollSpeed:1000,
	            easingType: "easeOutBounce"
	        });						
		},
 		efectZoom:function(){ //-------> Efecto Zomm   
			/***********ZOOM************/
			if ($("#zoom").length > 0)
				{document.getElementById("zoom").addEventListener("mousemove", function(event) {
					zoom(event);
			});}
			function zoom(e){
				var zoomer = e.currentTarget;
				if ( e.offsetX >0 &&  e.offsetY > 1) {
				e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
				e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
						 
				x = offsetX/zoomer.offsetWidth*100
				y = offsetY/zoomer.offsetHeight*100
					zoomer.style.backgroundPosition = x + '% ' + y + '%';
				}
			}
		},
		notiEfect:function(){ //-------> Efect Aparece 
			let ver_noty_01 = new IntersectionObserver(  
				function (data) {
					let info = data[0];
					info.target.classList.toggle("visible_noty_1", info.isIntersecting);
					},
					{   threshold: [0.2]  }
			);
		 	let ver_noty_02 = new IntersectionObserver(  
				function (data) {
					let info = data[0];
					info.target.classList.toggle("visible_noty_2", info.isIntersecting);
					},
					{   threshold: [0.2]  }
			);

			if ( $(".card_noty1").length > 0 ){ 
				ver_noty_01.observe(document.querySelector(".card_noty1"));
			}
			if ( $(".card_noty2").length > 0 ){ 
				ver_noty_02.observe(document.querySelector(".card_noty2"));
			}
		},
		carruselProdNuevo:function(){
 			$('#carousel').owlCarousel({
				nav: true,
				navText: ['', ''],
				rewindNav : true,
				loop:true,  
				autoplay:false,
		 	  responsiveClass:true,
				responsive:{
					0:{
						items:1,
						nav:true
					},
					600:{
						items:1,
						nav:true
					},
					1000:{
						items:1,
						nav:true,
						loop:true
					}
				}
			});
		},
 		carruselMarcas:function(){//-----> OWL carusel     
			$("#owl-demo").owlCarousel({
				navText : ['',''],
				rewindNav : true,
				loop:true,  
				autoplay:false,
 				responsiveClass:true,
				responsive:{
					0:{
						items:1,
						nav:true
					},
					600:{
						items:3,
						nav:true
					},
					1000:{
						items:5,
						nav:true,
						loop:true
					}
				}
			});  
		},
		scriptBaykal:function(){

  
		  //---------> inicio del scrip js
			var contentWidth = document.body.clientWidth || 0;

			// sticky
			$(function(){
			  var offsetHeader = 200;
			  $(window).on('scroll',function() {
			    var scroll = getCurrentScroll();
			    if ( scroll >= offsetHeader ) {
			       $('.hdr').addClass('sticked');
			       if( $('body').hasClass('main') ) {
			        $('.hdr').removeClass('hdr_mainpage');
			      }
			    }
			    else {
			      $('.hdr').removeClass('sticked');
			      if( $('body').hasClass('main') ) {
			        $('.hdr').addClass('hdr_mainpage');
			      }
			    }
			  });
			  function getCurrentScroll() {
			    return window.pageYOffset || document.documentElement.scrollTop;
			  }
			});


			// scroll off
			function offScroll() {
			  var winScrollTop = $(window).scrollTop();
			  $(window).bind('scroll',function () {
			    $(window).scrollTop(winScrollTop);
			  });
			}
 
  		// sliders

		  // hero
		  $('.hero__lst').on('init', function(event, slick){
		     var $items = slick.$dots.find('li');
		     $items.addClass('slider__dots-itm');
		     $items.find('button').remove();
		  });
		  $('.hero__lst').slick({
		    infinite: true,
		    dots: true,
		    dotsClass: 'hero__dots-lst',
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    speed: 1000,
		    arrows: false,
		    easing: 'linear',
		  });

		  // about
		  $('.slider-about__lst').on('init', function(event, slick){
		     var $items = slick.$dots.find('li');
		     $items.addClass('slider__dots-itm');
		     $items.find('button').remove();
		  });
		  $('.slider-about__lst').slick({
		    infinite: true,
		    dots: true,
		    dotsClass: 'slider__dots-lst',
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    speed: 1000,
		    arrows: false,
		    cssEase: 'ease',
		    easing: 'linear',
		    fade: true,
		  });

		  // news
		  $('.news__lst').slick({
		    rows: 2,
		    slidesPerRow: 2,
		    dots: false,
		    infinite: false,
		    speed: 300,
		    centerMode: true,
		    centerPadding: '0',
		    slidesToShow: 1,
		    slidesToScroll: 2,
		    arrows: true,
		    nextArrow: '<a class="news_next news__ctrls"><svg class="icon_news" viewBox="0 0 32 32"><use xlink:href="img/baikal_defs.svg#arrow_down"/></svg></a>',
		    prevArrow: '<a class="news_prev news__ctrls"><svg class="icon_news" viewBox="0 0 32 32"><use xlink:href="img/baikal_defs.svg#arrow_down"/></svg></a>',
		    responsive: [{
		      breakpoint: 769,
		      settings: "unslick"
		    }]
		  });
		  if (contentWidth < 769) {
		    $('.news__lst').slick({
		      dots: false,
		      infinite: false,
		      speed: 300,
		      slidesToShow: 1,
		      slidesToScroll: 1,
		      arrows: true,
		      nextArrow: '<a class="news_next news__ctrls"><svg class="icon_news" viewBox="0 0 32 32"><use xlink:href="img/baikal_defs.svg#arrow_down"/></svg></a>',
		      prevArrow: '<a class="news_prev news__ctrls"><svg class="icon_news" viewBox="0 0 32 32"><use xlink:href="img/baikal_defs.svg#arrow_down"/></svg></a>',
		    });
		  }

		  // slideshow
		  $('.slideshow-disp').slick({
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    arrows: false,
		    fade: false,
		    asNavFor: '.slideshow-thumbs',
		    infinite: false,
		  });
		  $('.slideshow-thumbs').slick({
		    slidesToShow: 3,
		    slidesToScroll: 1,
		    arrows: true,
		    nextArrow: '<a class="slideshow-thumbs_next slideshow-thumbs__ctrls"><svg class="icon_slideshow-thumbs" viewBox="0 0 32 32"><use xlink:href="img/baikal_defs.svg#arrow_down"/></svg></a>',
		    prevArrow: '<a class="slideshow-thumbs_prev slideshow-thumbs__ctrls"><svg class="icon_slideshow-thumbs" viewBox="0 0 32 32"><use xlink:href="img/baikal_defs.svg#arrow_down"/></svg></a>',
		    fade: false,
		    vertical: true,
		    asNavFor: '.slideshow-disp',
		    focusOnSelect: true,
		    centerMode: true,
		    centerPadding: '0',
		    infinite: false,
		    autoplay: true,
		    responsive: [{
		      breakpoint: 767,
		      settings: {
		        rows: 1,
		        vertical: false,
		      }
		    }]
		  });

		  // menu show
		  $(function(){
		    
		    $('.js-showMenu').on('click', function(){
		      var menuShow = new TimelineMax;
		      if ( $('.body').hasClass('showMenu') ) {
		        menuShow.reverse();
		        // var menuHide = new TimelineMax;
		        // menuHide
		        // .staggerFromTo('.menu__itm', 0.5, {opacity:1,x: 0}, {opacity: 0,x: -100, ease: Back.easeOut.config(3)}, 0.03)
		        // .to(".wrap_menu", .7, { x: "-100%", ease: Power1.easeOut }, );

		        $('.body').removeClass('showMenu');
		        $('.menu__lst').removeClass('active');
		        $(window).unbind('scroll');
		      }
		      else {
		        
		        
		        $('.body').addClass('showMenu');
		        menuShow
		        .to(".wrap_menu", .7, { x: "0", ease: Power1.easeOut }, "0")
		        .staggerFromTo('.menu__itm', 0.5, {opacity:0,x: -100}, {opacity: 1,x: 0, ease: Back.easeOut.config(3)}, 0.03);
		        offScroll();
		      }
		    });
		  });

			function showSubMenu() {
			  if (contentWidth > 768) {
			      $(function() {
			      $(".menu__lnk").on("mouseenter",function(){
			        var $this = $(this);
			        // var subMenuHide = new TimelineMax;
			          
			        if($(this).parent().hasClass("active")) {
			          $(this).parent().removeClass("active");
			          // subMenuHide
			          // // 
			          // .staggerFromTo($('.submenu__itm'), 0.5, {opacity:1,x: 0}, {opacity: 0,x: -30, ease: Back.easeOut.config(3)}, 0.03);
			          // .from(".wrap_menu", .7, { x: "-100%", ease: Power1.easeOut }, "0")
			        } else {
			          // var subMenuShow = new TimelineMax;
			          // subMenuShow
			          // .to($('.submenu'), )
			          // // .from(".wrap_menu", .7, { x: "-100%", ease: Power1.easeOut }, "0")
			          //   .staggerFromTo($('li'), 0.5, {opacity:0,x: -30}, {opacity: 1,x: 0, ease: Back.easeOut.config(3)}, 0.03);
			            $(this).parent().siblings().removeClass("active");
			            $(this).parent().toggleClass("active");
			        }
			      });
			    })
			  }
			  else {
			    $(function() {
			      $(".menu__lnk").on("click",function(e){
			      	var $this = $(this);
			      	if(0 < $this.closest('li').find('ul').length) {
				      	e.preventDefault();
			      	}
			        if($(this).parent().hasClass("active")) {
			          $(this).parent().removeClass("active");
			          $(this).parent().parent().removeClass("active")
			        } else {
			          $(this).parent().siblings().removeClass("active");
			          $(this).parent().toggleClass("active");
			          $(this).parent().parent().toggleClass("active")
			        }
			      });
			    })
			  }
			}
			showSubMenu();
		},
		carrusel_cursos:function(){//--> OWL CLIENT (carl)
                  $("#owl-demo1").owlCarousel({
                      nav: true,
                      navText: ['', ''],
                      rewindNav : true,
                      loop:true,  
                      autoplay:true,
                                    autoplayTimeout:5000,
                      responsiveClass:true,
                      responsive:{
                        0:{
                          items:1,
                          nav:true
                        },
                        600:{
                          items:1,
                          nav:true
                        },
                        1000:{
                          items:3,
                          nav:true,
                          loop:true
                        }
                      }
                    });  
    },
    			 		
	}
	  Toptitop()
 }(jQuery, window); 


 
         

 





           




    


 









 
 

















